export const INITIAL_FORM_DATA = {
  starting_date: '',
  country_id: null,
  file: null,
  organization_name: '',
  activate_discount_rule: false,
  discount_rule: '',
};

export const MODAL_WIDTH = 'w-[400px]';
export const MODAL_MAX_HEIGHT = 'max-h-[75vh]';
export const TEXTAREA_ROWS = 4;
export const YEAR_DROPDOWN_ITEM_COUNT = 100;
export const DATE_FORMAT = 'dd MMM yyyy';
export const ACCEPTED_FILE_TYPES = '.pdf';
export const SUPPORTED_FORMATS_LABEL = 'pdf';
// Existing legacy colors used by DocumentIcon — preserved verbatim from origin
// to keep pixel-perfect parity with pre-refactor visual output.
export const FILE_DOC_PRIMARY_COLOR = '#6D51D7';
